import styled from 'styled-components';

export const PersonalInformationContainer = styled.div`
  padding: 30px 20px 0px 60px;

  flex: 1;

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    padding: 0px;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  & .mail {
    color: #8a8a8a;
  }
`;

export const PersonalInformationWrapper = styled.div`
  max-width: 500px;
  & .heading {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  & .btn-edit {
    cursor: pointer;
  }
  & .btn-update {
    display: flex;
    justify-content: flex-end;
  }
  & .setting-title {
    @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
      display: none;
    }
  }
`;
